import {
  Box,
  Card,
  CardContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { ClassificationReportResponse } from '@src/types/classificationReport'
import { useTranslation } from 'react-i18next'

interface ReportSummaryProps {
  reportData: ClassificationReportResponse
}

const ReportSummary = ({ reportData }: ReportSummaryProps) => {
  const { t } = useTranslation()

  return (
    <>
      {/* Summary Cards */}
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 2, mb: 3 }}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              {t('reports.totalDocuments')}
            </Typography>
            <Typography variant="h4">{reportData.totalDocuments}</Typography>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              {t('reports.finalizedDocuments')}
            </Typography>
            <Typography variant="h4">{reportData.finalizedDocuments}</Typography>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              {t('reports.documentsWithAnalyzedPages')}
            </Typography>
            <Typography variant="h4">{reportData.documentsWithAnalyzedPages}</Typography>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              {t('reports.totalPages')}
            </Typography>
            <Typography variant="h4">{reportData.totalPages}</Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Documents by Status */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {t('reports.documentsByStatus')}
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('reports.status')}</TableCell>
                <TableCell align="right">{t('reports.count')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportData.documentsByStatus.map((item) => (
                <TableRow key={item.status}>
                  <TableCell>{item.status}</TableCell>
                  <TableCell align="right">{item.count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )
}

export default ReportSummary
